export default __webpack_public_path__ + "static/media/paypal.48355257.svg";